<template>
  <div class="neumorphism-out centers-list-bg">
    <div class="centers-list-title">{{ $t("CentersList.title") }}</div>
    <ul class="centers-list" style="margin-left: 0px; padding-left: 0px">
      <li
        class="centers-list-item"
        v-for="i in centers"
        :key="i.id"
        @click="onClick(i)"
        @mouseover="onMouseOver(i)"
        @mouseleave="onMouseLeave(i)"
      >
        <v-icon :color="i.color">mdi-circle</v-icon>
        <span class="center-name">{{ i.centerGroupName }}</span>

        <CentersOccupancyRate
          v-if="bookingsFetched"
          :centers="centersByCenterGroupId(i.centerGroupId)"
          :interval="today"
          style="display: inline"
        >
          <template v-slot:content="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <span v-on="on">
                  <span style="display: inline-block; min-width: 70px">
                    <v-progress-circular
                      :value="item.desksRate * 100"
                      :size="20"
                      :width="2"
                      color="red darken-3"
                      v-on="on"
                    />
                    <sub style="margin-left: 2px">
                      {{ item.desksRatePercent }}
                    </sub>
                  </span>
                  <v-icon small style="vertical-align: sub">
                    {{ "mdi-widgets-outline" }}
                  </v-icon>
                  <sub>
                    {{ item.numRooms }}
                  </sub>
                </span>
              </template>
              <span>{{ $t("occupancyRates.occupancyRateWithNumRooms") }}</span>
            </v-tooltip>
          </template>
        </CentersOccupancyRate>
        <v-progress-circular
          v-else
          :size="20"
          :width="2"
          color="red darken-3"
          indeterminate
        />
      </li>
    </ul>
  </div>
</template>

<script>
import CentersOccupancyRate from "@/components/components-salles/public/booking/CentersOccupancyRate";
import { DateTime, Interval } from "luxon";
import { mapGetters } from "vuex";

export default {
  name: "centers-list",
  components: {
    CentersOccupancyRate,
  },
  props: {
    centers: null,
  },
  data: () => ({
    today: Interval.fromDateTimes(
      DateTime.now().set({ hour: 9, minutes: 0, seconds: 0 }),
      DateTime.now().set({ hour: 18, minutes: 0, seconds: 0 })
    ),
  }),
  computed: {
    ...mapGetters("bookingModule", {
      bookingsFetched: "wasBookingsFetched",
    }),
    ...mapGetters("centerModule", {
      centersByCenterGroupId: "getCentersByCenterGroupId",
    }),
  },
  methods: {
    /**
     * Notifies the parent component that a click occurred on a center element
     * and transmits data to identify its associated center
     */
    onClick(center) {
      this.$emit("click", center);
    },
    onMouseOver(center) {
      this.$emit("mouseover", center);
    },
    onMouseLeave(center) {
      this.$emit("mouseleave", center);
    },
  },
};
</script>

<style lang="scss" scoped>
.centers-list-bg {
  border-radius: 30px;
  padding: 15px;

  .centers-list {
    list-style-type: none;
    margin-top: 10px;
    width: fit-content;
    height: fit-content;
    max-width: 270px;
    max-height: 600px;
    overflow-x: hidden;
    overflow-y: auto;
  }
}

.centers-list-title {
  user-select: none;
  text-align: center;
  color: var(--text-color);
}

.centers-list-item {
  user-select: none;
  padding: 0.3em 1em;
  cursor: pointer;
}

.centers-list-item:hover {
  background: #64646410;
}

.centers-list-item:active {
  background: #64646420;
}

.center-name {
  text-transform: capitalize;
  display: inline-block;
  min-width: 100px;
  margin-left: 5px;
  vertical-align: middle;
}
</style>
